import React, { useState } from "react"
import { Squeeze as Hamburger } from 'hamburger-react'
import { Link } from "gatsby"

const Header = ({title, location, language, multiLangs}) => {
  let header
  let langMenu
  let pathJa
  let pathEn
  let availableLang
  const currentPath = location.pathname
  const [isOpen, setOpen] = useState(false)

  if (language === undefined || language === null) {
    language = 'ja'
  }

  if (multiLangs !== undefined && multiLangs !== null) {
    multiLangs.forEach(element => {
      const path = currentPath.replace(/(?<=^.{1}).{2}/, element)

      switch (element) {
        case 'ja':
          pathJa = path
          break
        case 'en':
          pathEn = path
          break
        default:
          break
      }
      if (element.toString() !== language.toString()) {
        availableLang = element
      }
    })
  } else {
    pathJa = currentPath.replace(/(?<=^.{1}).{2}/, 'ja')
    pathEn = currentPath.replace(/(?<=^.{1}).{2}/, 'en')
    
    if (pathEn.toString() === '/') {
      pathEn = '/en'
    }
    availableLang = (language === 'en') ? 'ja' : 'en'
  }

  const toggleHamburger = () => {
    setOpen(!isOpen)
  }

  header = (
    <h1 className="main-heading">
      <Link to={`/${language}/`}>{title}</Link>
    </h1>
  ) 

  langMenu = (
    <>
      {
        (availableLang !== undefined && availableLang !== null ) && (availableLang.toString() === 'ja') && (
          <span><Link to={pathJa}>JA</Link></span>
        )
      }
      {
        (availableLang !== undefined && availableLang !== null ) && (availableLang.toString() === 'en') && (
          <span><Link to={pathEn}>EN</Link></span>
        )
      }
    </>
  )

  // category name list
  const categoryNames = [
    { "slug": "lifestyle", "name": "LIFESTYLE" },
    { "slug": "food", "name": "FOOD" },
  ]

  const categoryList = (
    <>
        {Object.keys(categoryNames).map((key, index) => {
          const path = `/${language}/category/${categoryNames[key]["slug"]}/`
          const isCurrenct = (location.pathname.toString() === path.toString()) 

          return (
            <li key={index}>
              <Link to={path}
                itemProp="url"
                className={isCurrenct ? "current" : ""}
              >
                {categoryNames[key]["name"]} 
              </Link>
            </li>
            )
        })}
        <li>
          <Link to={`/${language}/about`}
            itemProp="url">
            ABOUT
          </Link>
        </li>
    </>
  )

  return (
    <>
      <header className="global-header">

        <div>
          <div
              className="hamburger"
              onClick={toggleHamburger}
            >
              <Hamburger toggled={isOpen} toggle={setOpen} size={20} />
          </div>
          <div className="header-nav">
            <div className="link">
              <div className="nav-category">{ categoryList }</div>
              <div className="nav-lang">{ langMenu }</div>
            </div>
          </div>
        </div>

        {header}
        <div className="lang-menu">
          {langMenu}
        </div>

        <ul className="category-list">
          { categoryList }
        </ul>
      </header>

      <style jsx="true">{`
        .header-nav {
          display: ${isOpen ? 'inline' : 'none'};
          background-color: white;
          opacity: 0.9;
          height: 100vh;
          width: 100vw;
          position: fixed;
          z-index: 100;
        }
      `}
      </style>
    </>
  )
}

export default Header
